import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import Autocomplete from './autocomplete';

const AutocompleteControlled = (props) => {
    const { control, name, rules } = props;

	return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={undefined}
            render={() => (
                <Autocomplete
                    {...props}
                />
            )}
        />
	);
}

AutocompleteControlled.propTypes = {
    control: PropTypes.object,
    name: PropTypes.string,
    rules: PropTypes.object
}

export default AutocompleteControlled;
